import React from 'react';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { SessionTimeoutWarning } from './SessionTimeoutWarning';

interface SessionTimeoutGateProps {
  children: React.ReactNode;
}

export const SessionTimeoutGate: React.FC<SessionTimeoutGateProps> = ({ children }) => {
  const { showWarning, timeRemaining, warningType, continueSession, signOut, expired } = useSessionTimeout();

  return (
    <>
      {showWarning && (
        <SessionTimeoutWarning
          timeRemaining={timeRemaining}
          warningType={warningType}
          onContinue={continueSession}
          onSignOut={signOut}
          onExpired={expired}
        />
      )}
      {children}
    </>
  );
};
